import { captureException } from 'client/lib/sentry';

// A simple regex to match UUID patterns
const uuidRegex = /^[\w]{8}-[\w]{4}-[\w]{4}-[\w]{4}-[\w]{12}$/i;

// Takes a file URL in `/files/:id.[extension]` format
// and returns the file ID if it's a valid UUID
function fileURLToID(url: string) {
  const id = url.split('/')[2].split('.')[0];
  if (uuidRegex.test(id)) {
    return id;
  }
}

// Extract media files from the lesson content
export function extractMediaFiles(content: string) {
  try {
    const parser = new DOMParser();
    const document = parser.parseFromString(content, 'text/html');
    const ids = Array.from(document.querySelectorAll('video,audio')).map((el) => {
      const mediaState = JSON.parse(el.getAttribute('data-state') || '{}');
      if (mediaState?.url) {
        // Takes a file URL in `/files/:id.[extension]` format
        // and returns the file ID if it's a valid UUID
        // return mediaState.url.split('/')[2].split('.')[0];
        const fileId = fileURLToID(mediaState.url);
        return fileId;
      }
    });
    return ids.filter((x) => !!x) as UUID[];
  } catch (e) {
    // Log the error to Sentry and fall back to an empty array
    console.error(e);
    captureException(e);
    return [];
  }
}
